import React, { useEffect, useState } from 'react';
import { getActivitiesData, removeResourceData } from '../../firebase.js';
import { Navbar, Container, Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import "../Dashboard/Dashboard.css"; 
import { BiEdit , BiTrash, BiCopy} from "react-icons/bi";
import { BsLink45Deg } from "react-icons/bs";
import ResourceModal from "../ResourceModal/ResourceModal"; 
import Loading from "../Loading/Loading"
import Sidebar from "../Sidebar/Sidebar";
import { filterItemsBySearch } from "../../utils/filterItemsBySearch";

function Resources() {
    const [resourceLists, addData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [status, setStatus] = useState("create");
    const [resourceData, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [searchInput, setSearchInput] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [showDelete, setShow] = useState(false);
    const [delresourceData, setDeleteData] = useState({});

    useEffect(() => {
        getActivitiesData().then((lists) => {
            var arrActivity = [];
            lists.forEach((ele) => {
                arrActivity.push(ele.data());
            });
            addData(arrActivity);
            setLoading(false)
        }).catch((err) => console.log(err));
    }, []);
    console.log(resourceLists)

    function editActivityInfo(activity) {
        let getActInfo = activity.data;
        setShowModal(true)
        setStatus("edit")
        setData(actInfo => ({ ...actInfo, ...getActInfo }));
    }  
    
    function duplicateResource(activity) {
        let getActInfo = activity.data;
        setShowModal(true)
        setStatus("duplicate")
        setData(actInfo => ({ ...actInfo, ...getActInfo }));
    }
    
    function deleteResource() {
        let resourceData = delresourceData.data;
        setShow(false)
        addData(resourceLists.filter((item) => item.id !== resourceData.id));
        setLoading(true);
        removeResourceData(resourceData.id).then(() => {
            setTimeout(() => setLoading(false), 500)
        });
    }

    const searchItems = (searchValue) => { 
        setSearchInput(searchValue)
        setFilteredResults(filterItemsBySearch(resourceLists, searchValue));
    }

    return ( 
        <>
        {loading === false ? (
            <Container fluid>
                <Row> 
                    <Sidebar/> 
                    <Col lg={10} md={9} className="ms-sm-auto px-md-4">
                        <Navbar>
                            <h3 className='py-3'>All Resources</h3><h3 className='py-3 slagcolor'></h3> 
                            <Col md={7} className='py-3'>
                                <Form className='p-1 col-md-8 mx-auto searchBox'>
                                    <Form.Control type="text" placeholder="Search by Resources" className='text-center rounded-lg'  onChange={(e) => searchItems(e.target.value)}/>
                                </Form>
                            </Col>
                            <Col md={3} className="d-flex align-items-center justify-content-end">
                                <Button variant="primary"  onClick={() => {setShowModal(true); setStatus("create")}}>Create Resource</Button>
                                <ResourceModal show={showModal} close={() => setShowModal(false)} status={status} resource={resourceData} />
                            </Col>
                        </Navbar> 
                        <Container className='datacontainer p-0'>
                            <Table hover>
                                <thead style={{position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10}}>
                                    <tr>
                                        <th>No.</th>
                                        <th>Title</th>
                                        <th>Image</th>
                                        <th>Description</th>
                                        <th>Category</th>
                                        <th>Page</th>
                                        <th>Date</th>
                                        <th>Links</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className='tabledata'>
                                    {searchInput.length > 1 ? (
                                        <> 
                                            {filteredResults.map((data, index) =>(
                                                <tr key={index} className="py-4" style={{maxHeight: '150px'}}>
                                                    <td><label>{index+1}.</label></td>
                                                    <td className='col-md-2'><label>{data.title}</label></td>
                                                    <td className='col-md-3'><img src={data.image} className="img-fluid" alt={data.image}/></td>
                                                    <td className='col-md-5'>
                                                        <div style={{maxHeight: '120px', overflowY: 'auto', overflowX: 'hidden'}}>
                                                            <label>{data.description}</label>
                                                        </div>
                                                    </td>
                                                    <td className='col-md-1'>
                                                        <div>
                                                            <label>{data.category}</label>
                                                            {data.courseCategory && (
                                                                <div style={{marginTop: '4px'}}>
                                                                    <span style={{
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        color: '#1976d2',
                                                                        borderRadius: '12px',
                                                                        display: 'inline-block'
                                                                    }}>
                                                                        {data.courseCategory === 'waste' ? 'Waste Management' :
                                                                         data.courseCategory === 'development' ? 'Conservation & Sustainable Development' :
                                                                         data.courseCategory === 'marine' ? 'Marine Science' :
                                                                         data.courseCategory === 'geology' ? 'Geospatial & Geology' :
                                                                         data.courseCategory}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className='col-md-1'><label>{data.page}</label></td>
                                                    <td className='col-md-1'><label>{data.date}</label></td>
                                                    <td className='col-md-1'>{data.links.map((url, index) =>
                                                        <a href={url.link} target='_blank' key={index} className='d-block text-success'> {url.title} </a>)}
                                                    </td>
                                                    <td className='editIcon'> 
                                                        <BiEdit onClick={() => editActivityInfo({data})} style={{cursor: 'pointer'}}/>
                                                        <BiCopy onClick={() => duplicateResource({data})} style={{cursor: 'pointer'}}/>
                                                        <BiTrash onClick={() => {setShow(true);setDeleteData({ data })}} style={{marginLeft: '8px', cursor: 'pointer'}} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <>  
                                            {resourceLists.map((data, index) =>(
                                                <tr key={index} className="py-4" style={{maxHeight: '150px'}}>
                                                    <td><label>{index+1}.</label></td>
                                                    <td className='col-md-2'><label>{data.title}</label></td>
                                                    <td className='col-md-2'><img src={data.image} className="img-fluid" alt={data.image}/></td>
                                                    <td className='col-md-3'>
                                                        <div style={{maxHeight: '120px', overflowY: 'auto', overflowX: 'hidden'}}>
                                                            <label>{data.description}</label>
                                                        </div>
                                                    </td>
                                                    <td className='col-md-1'>
                                                        <div>
                                                            <label>{data.category}</label>
                                                            {data.courseCategory && (
                                                                <div style={{marginTop: '4px'}}>
                                                                    <span style={{
                                                                        fontSize: '0.75rem',
                                                                        padding: '2px 8px',
                                                                        backgroundColor: '#e3f2fd',
                                                                        color: '#1976d2',
                                                                        borderRadius: '12px',
                                                                        display: 'inline-block'
                                                                    }}>
                                                                        {data.courseCategory === 'waste' ? 'Waste Management' :
                                                                         data.courseCategory === 'development' ? 'Conservation & Sustainable Development' :
                                                                         data.courseCategory === 'marine' ? 'Marine Science' :
                                                                         data.courseCategory === 'geology' ? 'Geospatial & Geology' :
                                                                         data.courseCategory}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className='col-md-1'><label>{data.page}</label></td>
                                                    <td className='col-md-1'><label>{data.date}</label></td>
                                                    <td className='col-md-1'>{data.links.map((url, index) =>
                                                        <a href={url.link} target='_blank' key={index} className='d-block text-success'> {url.title} </a>)}
                                                    </td>
                                                    <td className='editIcon'> 
                                                        <BiEdit onClick={() => editActivityInfo({data})} style={{cursor: 'pointer'}}/>
                                                        <BiCopy onClick={() => duplicateResource({data})} style={{cursor: 'pointer'}}/>
                                                        <BiTrash onClick={() => {setShow(true);setDeleteData({ data })}} style={{cursor: 'pointer'}} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Container>
                    </Col>
                </Row>
                <Modal show={showDelete} onHide={() => setShow(false)} centered aria-labelledby="deleteModal">
                    <Modal.Header closeButton>
                    <Modal.Title id="deleteModal">
                        Are you sure to delete this resource?
                    </Modal.Title>
                    </Modal.Header> 
                    <Modal.Footer>
                            <Button variant="danger"   onClick={() => setShow(false)}> No </Button>
                            <Button variant="success"  onClick={() => deleteResource()}> Yes</Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        ) : (
            <Loading />
        )}
        </> 
    );
}
export default Resources;